<template>
  <div id="ComponentInventoryCreate" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <span class="page-title" id="itemHeader" v-if="$route.params.id > 0">Update PDC Stock</span>
          <span class="page-title" id="itemHeader" v-else>Add PDC Stock</span>
          <!-- <span id="itemHeader" v-else>Add Component Transaction</span> -->
          <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath">
            <i class="fp-back"> </i> Back
          </button>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content component-inventory-crud">
            <section class="internal-container border-top-table-fl">
              <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select"
                id="ComponentInventoryForm">
                <div class="form-row row-cols-md-4">
                  <div v-if="isAdmin" class="col form-group">
                    <label class="control-label require" for="component_id">Part:</label>
                    <v-select :disabled="!isComponentFilterable" @input="changeItem" v-model="component_id"
                      name="component_id" label="text" :filterable="isComponentFilterable" :options="itemArr"
                      @search="onSearchComponent" placeholder="Search Part" class="custom-ci-auto-search close-remove">
                      <template slot="no-options">
                        Search Part...
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.text }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.text }}
                        </div>
                      </template>
                    </v-select>
                    <div class="field-error">{{ component_error_msg }}</div>
                  </div>
                  <div v-if="!isAdmin" class="col form-group">
                    <label class="control-label" for="vendor_part">Vendor Part Number:</label>
                    <v-select v-model="vendorPart" name="vendor_part" placeholder=" Search Vendor Part"
                      @search="onSearchVendorPart" label="text" :options="vendorPartArr">
                    </v-select>
                    <div class="field-error">{{ vendorPartError }}</div>

                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="location_id">Location:</label>
                    <v-select :disabled="!isComponentFilterable" v-model="location_id" @change="changeLocation($event)"
                      name="location_id" placeholder="Select Location." label="text" :options="locationArr"
                      :filterable="isComponentFilterable">
                    </v-select>
                    <div class="field-error">{{ locationerrors }}</div>
                  </div>
                </div>
                <template v-if="selectedParts.length > 0 && isAdmin">
                  <div class="form-row row-cols-md-4 row-cols-1 permission-lists pl-1 pr-3">
                    <div class="permission-inside-list">
                      <template v-for="(mp, index) in selectedParts">
                        <div class="form-row" :key="index">
                          <label class="col">{{ mp.text }}</label>
                          <div class="col" v-if="$route.params.id == undefined">
                            <a href="javascript:void(0)" v-on:click.prevent="removeSelectedPart(index, mp)"> <i
                                class="fp-remove color-red"></i> </a>
                          </div>
                        </div>
                        <p :key="index + 'p'">&nbsp;&nbsp;</p>
                      </template>
                    </div>
                  </div>
                </template>
                <div class="form-row row-cols-md-4">

                  <div class="col form-group">
                    <label class="control-label" for="bin">Bin:</label>
                    <v-select v-model="bin" name="bin" placeholder=" Search Bin" @search="onSearchEvPartBin" label="text"
                      :options="binArr">
                    </v-select>
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="stock_unit_id">Stock UOM:</label>
                    <v-select v-model="stock_unit_id" name="stock_unit_id" placeholder="Select Stock UOM." label="text"
                      :options="stockunitArr">
                    </v-select>
                    <div class="field-error">{{ stockuniterrors }}</div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label require" for="purchase_unit_id">Purchase UOM:</label>
                    <v-select v-model="purchase_unit_id" name="purchase_unit_id" placeholder="Select Purchase UOM."
                      label="text" :options="purchaseunitArr">
                    </v-select>
                    <div class="field-error">{{ purchaseuniterrors }}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label" for="onhand_min_qty">Onhand Min Qty:</label>
                    <input type="text" class="form-control" v-model="onhand_min_qty" id="onhand_min_qty"
                      placeholder="Enter Onhand Min Qty" name="onhand_min_qty" @keypress="isAmountCheck($event)">
                  </div>
                  <div class="col form-group">
                    <label class="control-label" for="onhand_max_qty">Onhand Max Qty:</label>
                    <input type="text" class="form-control" v-model="onhand_max_qty" id="onhand_max_qty"
                      placeholder="Enter Onhand Max Qty" name="onhand_max_qty" @keypress="isAmountCheck($event)">
                  </div>

                  <div class="col form-group">
                    <label class="control-label" for="qty_on_hand">Qty On Hand:</label>
                    <input type="text" class="form-control" v-model="qty_on_hand" id="qty_on_hand"
                      placeholder="Enter Onhand Qty" name="qty_on_hand" @keypress="isAmountCheck($event)">
                  </div>

                  <div class="col form-group">
                    <label class="control-label" for="qty_on_order">Qty On Order:</label>
                    <input type="text" class="form-control" v-model="qty_on_order" id="qty_on_order"
                      placeholder="Enter On Order Qty" name="qty_on_order" @keypress="isAmountCheck($event)">
                  </div>

                  <div class="col form-group">
                    <label class="control-label" for="amount_price_one">Amount Price 1:</label>
                    <br>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon4">$</span>
                      </div>
                      <template>
                        <input type="text" class="form-control text-right" v-model="amount_price_one" id="amount_price_one"
                               placeholder="Enter Amount Price One" name="amount_price_one"
                               @keypress="isAmountCheck($event)">
                      </template>
                    </div>
<!--                        <input type="text" class="form-control" v-model="amount_price_one" id="amount_price_one"-->
<!--                        placeholder="Amount Price 1" name="amount_price_one" @keypress="isAmountCheck($event)">-->
                  </div>

                  <div class="col form-group">
                    <label class="control-label" for="order_multiplier">Order Multiplier:</label>
                        <input type="number" class="form-control" v-model="order_multiplier" id="order_multiplier"
                        placeholder="Order Multiplier" name="order_multiplier">
                  </div>
                </div>
                <div class="form-group">
                  <div class="alert alert-warning hide col-sm-6" id="alertError">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
                        aria-hidden="true">&times;</span></button>
                    <strong id="errorMsg" class="field-error"></strong>
                  </div>
                </div>
                <div class="btn-groups">
                  <button type="submit" id="CreateComponentInventoryBtn" v-if="$route.params.id > 0"
                    class="btn btn-primary" v-on:click.prevent="CreateComponentTransaction">
                    <i class="fp-reload"> </i> Update
                  </button>
                  <button type="submit" id="CreateComponentInventoryBtn" v-else class="btn btn-primary"
                    v-on:click.prevent="CreateComponentTransaction">
                    <i class="fp-add"> </i> Add
                  </button>
                  <button type="submit" id="cancelItemBtn" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath">
                    <i class="fp-close"> </i> Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import { commonMixins } from '../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";
import { contractMixins } from '../mixins/contractMixins';

Vue.component("loading-content", LoadingContent);

export default {
  name: "EvComponentInventoryCreate",
  components: {
    appFooter: () => import('@/components/Footer')
  },
  metaInfo() {
    return { title: (this.$route.params.id > 0) ? "Update PDC Stock | " + process.env.COPYRIGHT_NAME : "Add PDC Stock | " + process.env.COPYRIGHT_NAME }
  },
  mixins: [commonMixins, contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    vendor_id: null,
    vendorArr: [],
    quantity: 0,
    location_id: null,
    locationArr: [],
    location_row: "",
    location_shelf: "",
    location_bin: "",
    loading: false,
    locationerrors: '',
    base_price: 0,
    base_price_error_msg: '',
    warehouse_id: '',
    warehouseerrors: '',
    component_id: '',
    component_error_msg: '',
    itemArr: [],
    warehouseArr: [],
    bill_item_Id: '',
    billItemArr: [],
    woCompArr: [],
    wo_comp_id: '',
    isComponentFilterable: true,
    rsbArr: [],
    rsb_id: '',
    onhand_min_qty: '',
    onhand_max_qty: '',
    selectedParts: [],
    rsb_iderror: '',
    stock_unit_id: null,
    stockunitArr: [],
    stockuniterrors: "",
    purchase_unit_id: null,
    purchaseuniterrors: "",
    purchaseunitArr: [],
    disableSMou: false,
    disableMou: false,
    is_default: false,
    is_fuel_product: false,
    qty_on_hand: null,
    qty_on_order: null,
    amount_price_one: null,
    bin: null,
    binArr: [],
    vendorPart: null,
    vendorPartArr: [],
    isAdmin: false,
    vendorPartError: "",
    order_multiplier: 0,
    // create a searchable dropdown for the bin.

  }),
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  watch: {
    //check permission change
    permissions: function (permissions) {

      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name == 'add_component_transaction') {
            self.cantAccessPage = true;
          }
        }
      }

    }
  },
  created: function () {

  },
  mounted: function () {
    var self = this;
    self.getPermissions();
    var path = window.location.pathname;
    var segments = path.split("/");

    if (segments[3]) {

      self.loadItem();
      self.isComponentFilterable = false;
    } else {
      self.isComponentFilterable = true;
    }
    this.loadFieldData(['location', 'measurementUnit']);
    if (self.location_id !== null) {
      if (self.is_fuel_product) {
        self.loadFieldData(['fuel_warehouse'], self.location_id.value);
      } else {
        self.loadFieldData(['non_fuel_warehouse'], self.location_id.value);
      }
    } else {
      if (self.is_fuel_product) {
        self.loadFieldData(['fuel_warehouse'], '');
      } else {
        self.loadFieldData(['non_fuel_warehouse'], '');
      }
    }

    if (self.$route.query.inv_id != undefined && self.$route.query.inv_id > 0) {
      //self.fetchInventory();
    } else {

      if (userObj != null && userObj["location_id"] != null) {
        self.location_id = { value: userObj["location_id"], text: self.titleCase(userObj["locationName"]) + " (" + userObj["locationCode"] + ")" };
      }
    }
    var userObj = JSON.parse(localStorage.getItem("user_obj"));
    if (userObj.roles[0].name == "admin") {
      self.isAdmin = true;
    } else {
      self.isAdmin = false;
    }
  },
  methods: {

    changeItem: function () {
      var self = this;
      self.component_error_msg = '';
      if (self.component_id != null && self.component_id.mUnitId != undefined) {
        self.purchase_unit_id = { text: self.component_id.mUnitName + ' (' + self.component_id.mUnitCode + ')', value: self.component_id.mUnitId };
        // this.disableMou = true;
      } else {
        // this.disableMou = false;
        self.purchase_unit_id = '';
      }
      if (self.component_id != null && self.component_id.smUnitId != undefined) {
        self.stock_unit_id = { text: self.component_id.smUnitName + ' (' + self.component_id.smUnitCode + ')', value: self.component_id.smUnitId };
        // this.disableSMou = true;
      } else {
        // this.disableSMou = false;
        self.stock_unit_id = '';
      }
      if (self.selectedParts.length >= 1) {
        if (self.selectedParts[0]["itemCategoryCode"] === "FUEL" || self.selectedParts[0]["itemCategoryCode"] === "FUELNS") {
          self.is_fuel_product = true;
          if (self.component_id["itemCategoryCode"] === "FUEL" || self.component_id["itemCategoryCode"] === "FUELNS") {
            self.selectedParts.push(self.component_id);
          } else {
            self.component_error_msg = 'cannot add fuel and non fuel parts at the same time'
          }
        } else {
          self.is_fuel_product = false;
          if (self.component_id["itemCategoryCode"] === "FUEL" || self.component_id["itemCategoryCode"] === "FUELNS") {
            self.component_error_msg = 'cannot add fuel and non fuel parts at the same time'
          } else {
            self.selectedParts.push(self.component_id);
          }
        }
      } else {
        self.is_fuel_product = self.component_id["itemCategoryCode"] === "FUEL" || self.component_id["itemCategoryCode"] === "FUELNS";
        self.selectedParts.push(self.component_id);
      }
      setTimeout(function () {
        self.component_id = null;
        self.itemArr = [];
      }, 100);
      // return;
    },
    removeSelectedPart(index, part) {
      var self = this;
      if (self.selectedParts[index] != undefined && self.selectedParts[index] != null) {
        self.selectedParts.splice(index, 1);
      }
      if (self.selectedParts[index - 1] != undefined) {
        if (self.selectedParts[index - 1].mUnitId != undefined) {
          this.purchase_unit_id = { text: self.selectedParts[index - 1].mUnitName + ' (' + self.selectedParts[index - 1].mUnitCode + ')', value: self.selectedParts[index - 1].mUnitId };
          // this.disableMou = true;
        } else {
          // this.disableMou = false;
        }
        if (self.selectedParts[index - 1].smUnitId != undefined) {
          this.stock_unit_id = { text: self.selectedParts[index - 1].smUnitName + ' (' + self.selectedParts[index - 1].smUnitCode + ')', value: self.selectedParts[index - 1].smUnitId };
          // this.disableSMou = true;
        } else {
          // this.disableSMou = false;
        }
      }
      if (self.selectedParts.length <= 0) {
        self.location_id = null;
      }

    },
    onSearchComponent(search, loading) {
      var self = this;
      if (search != null && search.length > 2) {

        loading(true);
        self.searchField(loading, search, 'item', '');
      }
    },

    onSearchVendorPart(search, loading) {
      var self = this;
      if (search != null && search.length > 2) {

        loading(true);
        self.searchField(loading, search, 'vendor_part_number', '');
      }
    },

    onSearchEvPartBin(search, loading) {
      var self = this;
      if (search != null && search.length > 1) {
        loading(true);
        self.searchField(loading, search, 'ev_part_bin', '');
      }
    },

    BackItemList() {
      var self = this;

      self.$router.push("/pdc-stock/list");

    },

    CreateComponentTransaction(flag) {
      var self = this;
      var error = false;

      self.locationerrors = "";
      self.base_price_error_msg = '';
      self.rsb_iderror = '';
      self.vendorPartError = "";

      if ((!self.selectedParts.length || self.selectedParts == null || !self.selectedParts == undefined) && self.isAdmin) {
        self.component_error_msg = "Component Required.";
        error = true;
      }
      if (self.location_id == null || self.location_id == '' || !self.location_id.value) {
        self.locationerrors = "Location Required.";
        error = true;
      }

      if (self.purchase_unit_id == null || self.purchase_unit_id == '' || !self.purchase_unit_id.value) {
        self.purchaseuniterrors = "Purchase Unit Required.";
        error = true;
      }
      if (self.stock_unit_id == null || self.stock_unit_id == '' || !self.stock_unit_id.value) {
        self.stockuniterrors = "Stock Unit Required.";
        error = true;
      }

      if (!self.isAdmin && self.vendorPart == null) {
        self.vendorPartError = "Vendor Part Number is requried";
        error = true;
      }

      if (!error) {

        var path = window.location.pathname;
        var segments = path.split("/");
        if (segments[3]) {
          $("#CreateComponentInventoryBtn").val("Updating ...");
          $("#CreateComponentInventoryBtn").prop("disabled", true);
          $("#cancelItemBtn").prop("disabled", true);
        }

        var fields = $("#ComponentInventoryForm").serializeArray();
        fields.push({ name: "id", value: segments[3] });

        if ((self.selectedParts == null || !self.selectedParts.length) && !self.isAdmin) {
          self.selectedParts.push({ value: self.vendorPart.value, text: self.vendorPart.item_text });
          fields.push({ name: "items", value: JSON.stringify(self.selectedParts) });
        } else {
          fields.push({ name: "items", value: JSON.stringify(self.selectedParts) });
        }

        if (!self.isAdmin) {
          if (self.vendorPart == null) {
            fields.push({ name: "vendorPartNumber", value: '' });
          } else {
            fields.push({ name: "vendorPartNumber", value: self.vendorPart.value });
          }
        }

        if (self.location_id == null) {
          fields.push({ name: "location_id", value: "" });
        } else {
          fields.push({ name: "location_id", value: self.location_id.value });
        }

        if (self.bin == null) {
          fields.push({ name: "bin", value: "" });
        } else {
          fields.push({ name: "bin", value: self.bin.value });
        }
        fields.push({ name: "purchase_unit_id", value: self.purchase_unit_id.value });
        fields.push({ name: "stock_unit_id", value: self.stock_unit_id.value });
        fields.push({ name: "rsb_id", value: "" });
        fields.push({ name: "warehouse_id", value: "" });
        if (self.is_default == true) {
          fields.push({ name: "is_default", value: 1 });
        } else {
          fields.push({ name: "is_default", value: 0 });
        }

        // add fields for new fields
        fields.push({ name: "qty_on_hand", value: self.qty_on_hand });
        fields.push({ name: "qty_on_order", value: self.qty_on_order });
        fields.push({ name: "amount_price_one", value: self.amount_price_one });
        fields.push({name: "order_multiplier", value: self.order_multiplier});


        self.loading = true;
        $.ajax({
          url: process.env.ROOT_API + "/component-inventory/create",
          type: "POST",
          data: fields,
          headers: {
            "Accept": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Authorization": "Bearer " + localStorage.getItem("tkn"),
            "Access-Control-Allow-Headers":
              "Origin, Content-Type, Authorization,X-Requested-With",
            "Cache-Control": "no-cache"
          },
          dataType: "json",
          success: function (data) {

            self.loading = false;
            if (segments[3]) {
              $("#CreateComponentInventoryBtn").val("Update");
              $("#CreateComponentInventoryBtn").prop("disabled", false);
              $("#cancelItemBtn").prop("disabled", false);
            }

            if (data.status == 'count_exist') {
              self.$swal('', data.content, 'info');
              return;
            }

            if (data.status == "success") {

              self.$router.push("/pdc-stock/list");

            } else {
              if (data.content.length > 0) {
                var err = "";
                for (var i = 0; i < data.content.length; i++) {
                  err += data.content[i] + "<br>";
                }
                $("#errorMsg").html(err);
                $(".alert-warning").toggleClass("show");
                setTimeout(function () {
                  $(".alert-warning").removeClass("show");
                  $(".alert-warning").addClass("hide");
                }, 10000);
              }
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            if (segments[3]) {
              $("#CreateComponentInventoryBtn").val("Update");
              $("#CreateComponentInventoryBtn").prop("disabled", false);
              $("#cancelItemBtn").prop("disabled", false);
            }
            self.generateStatusCodeMessage(jqXHR, true, 'component-create')
          }
        });
      } else {
        self.errorValidationFocus();
      }

    },

    loadItem() {

      var path = window.location.pathname;
      var segments = path.split("/");
      var self = this;
      self.loading = true;

      $.ajax({
        url: process.env.ROOT_API + "/component-inventory/" + segments[3],
        type: "GET",
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status == "success") {

            if (data.content.itemId == null) {
              self.component_id = null;
            } else {
              self.component_id = { value: data.content.itemId, text: self.titleCase(data.content.itemName + " (" + data.content.itemCode + ")") };
            }
            self.selectedParts.push(self.component_id);

            if (data.content.location_id == null) {
              self.location_id = null;
            } else {
              self.location_id = { value: data.content.location_id, text: self.titleCase(data.content.locationName) + ' | ' + data.content.locCode };
            }

            if (data.content.stock_unit_id == null) {
              self.stock_unit_id = null;
            } else {
              self.stock_unit_id = { value: data.content.stock_unit_id, text: self.titleCase(data.content.mstUnitCode) + ' | ' + data.content.mstUnitName };
            }

            if (data.content.purchase_unit_id == null) {
              self.purchase_unit_id = null;
            } else {
              self.purchase_unit_id = { value: data.content.purchase_unit_id, text: self.titleCase(data.content.mUnitCode) + ' | ' + data.content.mUnitName };
            }

            if (data.content.onhand_min_qty == 0) {
              self.onhand_min_qty = "";
            } else {
              self.onhand_min_qty = data.content.onhand_min_qty;
            }
            if (data.content.onhand_max_qty == 0) {
              self.onhand_max_qty = "";
            } else {
              self.onhand_max_qty = data.content.onhand_max_qty;
            }

            self.qty_on_hand = data.content.quantity_on_hand;
            self.qty_on_order = data.content.quantity_on_order;
            self.amount_price_one = data.content.base_price;
            if (data.content.ev_part_bin_id != "" && data.content.ev_part_bin_id != null) {
              self.bin = { value: data.content.ev_part_bin_id, text: data.content.ev_bin }
            }

            if (!self.isAdmin) {
              var itemText = data.content.stock_part_number.concat("|", data.content.itemName);
              self.vendorPart = { value: data.content.itemId, text: data.content.vendorPart, item_text: itemText };
            }

            self.is_fuel_product = data.content.item_category_code === "FUEL" || data.content.item_category_code === "FUELNS";
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'component-by-id')
        }
      });
    },

    changeLocation: function () {
      var self = this;
      if (self.isAdmin) {
        if (self.selectedParts.length === 0) {
          self.component_error_msg = "Select a part before selecting location!"
          self.location_id = null;
        } else {
          if (self.location_id != null && self.location_id.value) {
            if (self.$route.params.id == undefined) {
              self.warehouse_id = '';
              self.rsb_id = '';
              self.onhand_min_qty = '';
              self.onhand_max_qty = '';
            }
            if (self.is_fuel_product) {
              self.loadFieldData(['fuel_warehouse'], self.location_id.value);
            } else {
              self.loadFieldData(['non_fuel_warehouse'], self.location_id.value);
            }
          }
        }
      }
    },

    isNumberKey: function (evt) {

      var self = this;

      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    titleCase(str) {
      if (str == null) {
        return;
      } else {
        var value = str.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/EvComponentInventoryCreate.vue